/** >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
 * Global `window.app` object
 * @global {object} app - contains components and other global functionality
 *     @function TwitterBlock
 *     @function ProgramsList
 *     @function NewsList
 *     @function EventsList
 *     @function Directory
 *     @function ResponsiveCarousel
 *     @function ResponsiveHomeCarousel
 *     @function Video
 *     @function Calendar
 * 
 * To invoke a specific component on any given specific page, invoke it by namespace:
 *     <script>window.app.Calendar()</script>
 * 
 * NOTE: componenents reuire a`selector` as the first argument:
 *     <script>window.app.TwitterBlock('#some-specific-DOM-element-ID')</script>
 * 
 * This use of components allows minification of JS files into a single file,
 * without needing to break them up for different pages.
*** >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>*/

import TwitterBlock from '/app/components/TwitterBlock.html'
import ProgramsList from '/app/components/ProgramsList.html'
import NewsList from '/app/components/NewsList.html'
import EventsList from '/app/components/EventsList.html'
import Directory from '/app/components/Directory.html'
import ResponsiveCarousel from '/app/components/ResponsiveCarousel.html'
import ResponsiveHomeCarousel from '/app/components/ResponsiveHomeCarousel.html'
import Video from '/global/components/video'
import Calendar from '/global/components/calendar'

window.app = {
	TwitterBlock: (target, url) => new TwitterBlock({
		target: document.querySelector(target),
		data: { url },
	}),
	ProgramsList: (target, url) => new ProgramsList({
		target: document.querySelector(target),
		data: { url },
	}),
	NewsList: (target, url) => new NewsList({
		target: document.querySelector(target),
		data: { url },
	}),
	EventsList: (target, url) => new EventsList({
		target: document.querySelector(target),
		data: { url },
	}),
	Directory: (target, url) => new Directory({
		target: document.querySelector(target),
		data: { url },
	}),
	ResponsiveCarousel: (target, url) => new ResponsiveCarousel({
		target: document.querySelector(target),
		data: { url },
	}),
	ResponsiveHomeCarousel: (target, url) => new ResponsiveHomeCarousel({
		target: document.querySelector(target),
		data: { url },
	}),
	Video,
	Calendar,
}
